const initialState = {
  growl: null,
};

const INIT_GROWL = 'INIT_GROWL';

export function initGrowl(growl) {
  return {
    type: INIT_GROWL,
    growl,
  };
}

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_GROWL:
      return { ...state, growl: action.growl };
    default:
      return state;
  }
};

export default appReducer;
